define( function() {
	return ( /^(?:checkbox|radio)$/i );
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/manipulation/var/rcheckableType.js
 ** module id = 456
 ** module chunks = 2
 **/